import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import http from '../../../lib/http/index.js';
import { createSelector } from 'reselect';

const fetchCuponesData = async () => {

};

export const getBatches = createAsyncThunk('GET_BATCHES', async (payload, thunkAPI) => {
    const batchEnvios = (await http.TABLE('/batch-envios-mail')).body;
    const registrosMails = (await http.TABLE('/registros-mail')).body;
    const cupones = (await http.TABLE('/cupones')).body;
    const personas = (await http.TABLE('/personas')).body;
    const clasesContratos = (await http.TABLE('/clasesContrato')).body;
    const cvus = (await http.TABLE('/cvus')).body;
    const adhesionesDebito = (await http.TABLE('/adhesiones-debito')).body;
    const tiposCampana = (await http.TABLE('/tipos-campana')).body;
    const contratos = (await http.TABLE('/info-contratos')).body;
    const data = {
        batchEnvios,
        registrosMails,
        cupones,
        personas,
        clasesContratos,
        cvus,
        adhesionesDebito,
        tiposCampana,
        contratos,
    }
    return data;
});

export const envioCupones = createAsyncThunk('POST_CUPONES', async (payload, thunkAPI) => {
    let res = await http.POST('/cupones-mensuales', payload);
    await thunkAPI.dispatch(getBatches()).unwrap();
    return res;
});
export const getDetallesBatch = createAsyncThunk('GET_DETALLES_BATCH', async (payload, thunkAPI) => {
    const res = (await http.TABLE(`/batch/${payload}`)).body
    return res

});
export const getCuponesRegistro = createAsyncThunk('GET_CUPONES_REGISTRO', async (payload, thunkAPI) => {
    const res = (await http.TABLE(`/registros-mail/${payload}`)).body
    return res

});
const initialState = {
    //pendingRequests: 0,
    fetching: 0,
    error: null,
    message: null,
    data: {},
    detallesBatch: null,
    cuponesRegistro: null
};

const envioCuponesSlice = createSlice({
    name: 'cupones',
    initialState,
    reducers: {
        cleanError: (state, action) => ({ ...state, error: null }),
        cleanMessage: (state, action) => ({ ...state, message: null }),
        resetData: (state, action) => ({ ...state, cupones: {...state.cupones, data: {}} }),
        resetData: (state, action) => ({ ...initialState }),
    },
    extraReducers: {
        [getBatches.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1, error: null, message: null }),
        [getBatches.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: action }),
        [getBatches.fulfilled]: (state, action) => ({ ...state, data: action.payload, fetching: state.fetching - 1 }),

        [envioCupones.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1, error: null, message: null }),
        [envioCupones.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudieron enviar los cupones!" }),
        [envioCupones.fulfilled]: (state, action) => ({
            ...state,
            fetching: state.fetching - 1,
            message: action.payload.status === 200 ? "Cupones enviados!" : null,
            error: action.payload.status != 200 ? "No se pudieron enviar los cupones!" : null,
        }),
        [getDetallesBatch.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1, detallesBatch: null }),
        [getDetallesBatch.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: action }),
        [getDetallesBatch.fulfilled]: (state, action) => ({ ...state, detallesBatch: action.payload, fetching: state.fetching - 1 }),

        [getCuponesRegistro.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1, cuponesRegistro: null }),
        [getCuponesRegistro.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: action }),
        [getCuponesRegistro.fulfilled]: (state, action) => ({ ...state, cuponesRegistro: action.payload, fetching: state.fetching - 1 }),

    },
})

export const { cleanError, cleanMessage, resetData } = envioCuponesSlice.actions
export default envioCuponesSlice.reducer;